import { render, staticRenderFns } from "./InnerCard.vue?vue&type=template&id=613d31b4&"
import script from "./InnerCard.vue?vue&type=script&lang=js&"
export * from "./InnerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports